const MINUTES_IN_DAY = 1440;
const MAX_SHIFT_MINUTES = 20 * 60;

export const SHIFT_ERROR_KEYS = {
  NAME_REQUIRED: 'positionTemplate.create.shifts.error.nameRequired',
  NAME_DUPLICATE: 'positionTemplate.create.shifts.error.nameDuplicate',
  SAME_AS_START: 'positionTemplate.create.shifts.error.sameAsStart',
  TOO_LONG: 'positionTemplate.create.shifts.error.tooLong',
};

export const getShiftDurationMinutes = ({ start, end }) =>
  (end - start + MINUTES_IN_DAY) % MINUTES_IN_DAY;

const getNameError = (shift, allShifts) => {
  const name = shift.name?.trim().toLowerCase();
  if (!name) return SHIFT_ERROR_KEYS.NAME_REQUIRED;

  const isDuplicate = allShifts.some(
    (other) => other.id !== shift.id && other.name?.trim().toLowerCase() === name
  );
  return isDuplicate ? SHIFT_ERROR_KEYS.NAME_DUPLICATE : null;
};

const getEndError = (shift) => {
  if (shift.start === shift.end) return SHIFT_ERROR_KEYS.SAME_AS_START;
  if (getShiftDurationMinutes(shift) > MAX_SHIFT_MINUTES) return SHIFT_ERROR_KEYS.TOO_LONG;
  return null;
};

export const getShiftErrors = (shift, allShifts = []) => {
  const errors = {};
  const nameError = getNameError(shift, allShifts);
  const endError = getEndError(shift);
  if (nameError) errors.name = nameError;
  if (endError) errors.end = endError;
  return errors;
};

export const isShiftValid = (shift, allShifts = []) =>
  Object.keys(getShiftErrors(shift, allShifts)).length === 0;
